var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:{'text-success': _vm.value >= 0 && _vm.color, 'text-danger': _vm.value < 0 && _vm.color}},[(_vm.value > 0)?[_vm._v("+")]:_vm._e(),_vm._v(_vm._s(_vm._f("price")(_vm.value))+" ")],2)}
var staticRenderFns = []

export { render, staticRenderFns }